import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

function WalmartPalletAllocationForm(props) {

    const [searchValue, setSearchValue] = useState("");

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!searchValue.trim()) return;

        props.getBulkOrderDetails(searchValue.trim());
    };

    return (
        <Box
            className={props.isMobile ? "mobile-box" : "desktop-box"}
            display="flex"
            flexDirection="column"
        >
            <form onSubmit={handleSubmit}>
                <Stack direction="row" alignItems="center">

                    <FormControl sx={{ width: '30%', mr: '10px' }}>
                        <TextField
                            label="PO Number or Sales Order Number"
                            value={searchValue}
                            onChange={(event) => setSearchValue(event.target.value)}
                        />
                    </FormControl>

                    <Button
                        type="submit"
                        disabled={props.isLoading || !searchValue.trim()}
                        variant="contained"
                        color="success"
                    >
                        Search
                    </Button>

                </Stack>
            </form>
        </Box>
    );
}

export default WalmartPalletAllocationForm;